import React from 'react';
import PropTypes from 'prop-types';

class RepeatGroup extends React.Component{

    state = {
        keyName: this.props.keyName,
        value: this.props.value
    }

    updateKeyName = (value) => {
        const state = {...this.state};
        state.keyName = value;
        this.setState({
            keyName: value
        });
        this.props.onChange(this.props.id, state);
    };

    updateValue = (value) => {
        const state = {...this.state};
        state.value = value;
        this.setState({
            value: value
        });
        this.props.onChange(this.props.id, state);
    };

    renderKeyName = () => {
        return (
                <div className="repeat-group">
                    <label>{this.props.fieldName}</label>
                    { this.props.type && this.props.type === 'textarea' ? <textarea value={this.state.keyName} onChange={(e) => this.updateKeyName(e.target.value)}></textarea> : <input type="text" value={this.state.keyName} onChange={(e) => this.updateKeyName(e.target.value)} /> }

                </div>
        );
    };

    renderValue = () => {
        return (
                <div className="repeat-group">
                    <label>Tag</label>
                    { this.props.type && this.props.type === 'textarea' ? <textarea value={this.state.keyName} onChange={(e) => this.updateKeyName(e.target.value)}></textarea> : <input type="text" value={this.state.value} onChange={(e) => this.updateValue(e.target.value)} /> }
                </div>
        );
    };

    render() {
        return (
            <div className="flex-between repeatGroup">
                {this.renderKeyName()}
                {this.props.value === null ? null : this.renderValue()}
                <a className="btn-remove" onClick={(e) => this.props.onRemove(this.props.id)}><i className="material-icons">cancel</i></a>
            </div>
        );
    }
}

RepeatGroup.propTypes = {
    keyName: PropTypes.string.isRequired,
    value: PropTypes.string,
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    fieldName: PropTypes.string.isRequired,
    type: PropTypes.string
}

export default RepeatGroup;


/** WEBPACK FOOTER **
 ** ./src/components/ui/RepeatGroup.js
 **/